<template>
	<div>
		<!-- MODAL MORE INFO -->
		<v-dialog v-model="dialog">
			<v-card>
				<v-card-title class="headline">{{ tituloEvento }}</v-card-title>
				<v-card-subtitle>{{ fechaEvento }}</v-card-subtitle>
				<v-card-text>{{ descripEvento }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="dialog = false">Cerrar</v-btn>
					<v-btn color="primary" text :href="linkEvento">Leer más</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- MESES -->
		<v-card v-for="(mes, m) in meses" :key="mes.mes" class="ma-3" :id="mes.mes">
			<v-card-title class="mesTitle">{{ mes.mes }}</v-card-title>
			<v-list>
				<v-list-item
					three-line
					v-for="(evento, i) in mes.eventos"
					:key="i"
					@click="openMoreInfo(i, m)"
				>
					<v-list-item-icon class="dia">
						{{ new Date(evento.fecha).getUTCDate() }}
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ evento.titulo }}</v-list-item-title>
						<v-list-item-subtitle>{{ evento.descripcion }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-card>

		<!-- NADA QUE MOSTRAR -->
		<nothing v-show="nothingToShow"></nothing>

		<!-- LOADING -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
import Nothing from "../components/Nothing";
import { CALENDARIO_API } from "../apiConfig";
import { getDataModule } from "../db_save";

export default {
	components: {
		Nothing
	},
	data: () => ({
		types: ["month", "week", "4day"],
		selectType: 0,
		eventos: [],
		meses: [],
		dialog: false,
		tituloEvento: "",
		descripEvento: "",
		fechaEvento: "",
		linkEvento: "",
		nothingToShow: false,
		loading: true
	}),
	created() {
		this.getEventos();
	},
	updated() {
		this.scrollMesActual();
	},
	methods: {
		orderByDate(arr) {
			//Menor a Mayor
			return arr.sort((a, b) => (new Date(a["fecha"]) > new Date(b["fecha"]) ? 1 : -1));
		},
		scrollMesActual() {
			let target = `#${this.getMesName(new Date().getMonth() + 1)}`;
			if (document.getElementById(this.getMesName(new Date().getMonth() + 1))) {
				//Si existe =>  scroll
				let options = {
					duration: 250,
					easing: "easeOutQuad"
				};
				this.$vuetify.goTo(target, options);
			}
		},
		getEventos() {
			//console.log("Get Eventos ", CALENDARIO_API);

			getDataModule("calendario", 1000 * 60 * 10, CALENDARIO_API)
				.then(eventos => {
					console.log("Eventos: ", eventos);
					if (eventos.length > 0) {
						this.eventos = this.orderByDate(eventos);
						this.agruparByMeses();
					} else {
						this.eventos = [];
						this.nothingToShow = true;
					}
				})
				.catch(e => {
					console.error("Error ", e);
				})
				.finally(() => {
					this.loading = false;
				});
			/*

			fetch(CALENDARIO_API)
				.then(response => response.json()) // one extra step
				.then(data => {
					console.log(data);
					this.eventos = this.orderByDate(data);
					this.agruparByMeses();
				})
				.catch(error => console.error(error));*/
		},
		agruparByMeses() {
			//console.warn("Ordenando!");
			let lastMes = "";
			let mesAct = "";
			let iMes = -1;

			for (let i = 0; i < this.eventos.length; i++) {
				mesAct = new Date(this.eventos[i].fecha).getMonth() + 1;

				if (mesAct != lastMes) {
					lastMes = mesAct;
					iMes++;

					this.meses.push({ mes: this.getMesName(mesAct), eventos: [] });
				}

				//Nuevo evento
				this.meses[iMes].eventos.push(this.eventos[i]);
			}
		},
		getMesName(num) {
			switch (num) {
				case 1:
					return "Enero";
				case 2:
					return "Febrero";
				case 3:
					return "Marzo";
				case 4:
					return "Abril";
				case 5:
					return "Mayo";
				case 6:
					return "Junio";
				case 7:
					return "Julio";
				case 8:
					return "Agosto";
				case 9:
					return "Septiembre";
				case 10:
					return "Octubre";
				case 11:
					return "Noviembre";
				case 12:
					return "Diciembre";
			}
		},
		openMoreInfo(idEvent, mesId) {
			this.tituloEvento = this.meses[mesId].eventos[idEvent].titulo;
			this.descripEvento = this.meses[mesId].eventos[idEvent].descripcion;
			let f = new Date(this.meses[mesId].eventos[idEvent].fecha);
			this.fechaEvento = `${f.getDate()}/${f.getMonth() + 1}/${f.getFullYear()}`;
			this.linkEvento = this.meses[mesId].eventos[idEvent].link;

			this.dialog = true;
		}
	}
};
</script>

<style>
.mesTitle {
	color: var(--v-primary-base);
}
.dia {
	color: var(--v-primary-base);
	font-weight: 300;
	font-size: x-large;
}
</style>
